import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createHashRouter, Navigate } from 'react-router-dom';
import { RouterProvider } from 'react-router';
import HomePage from './pages/HomePage'
import ProfilePage from './pages/NotFoundPage';
import NotFoundPage from './pages/NotFoundPage';
import { ThemeProvider } from '../src/ThemeContext.js';

const router = createHashRouter([
  {
    path: '/',
    element: <HomePage />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: '/:selectedContent',
        element: <HomePage />
      }
    ]
  },
  {
    path: '/profiles',
    element: <ProfilePage />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
